import { FC } from 'react';
import { SimpleFieldProps, SimpleFieldWithLabel } from './SimpleFieldWithLabel';

export const CurrencyField: FC<SimpleFieldProps> = ({ placeholder = '0.00', ...props }) =>
  <SimpleFieldWithLabel {...props} placeholder={placeholder} />;
